import Reveal from "@/components/Reveal";

const LAYERS = [
  {
    n: "01",
    label: "AI Signal Synthesis",
    desc: "AI helps identify and structure patient-relevant signals across digital, published, advisory, and real-world evidence sources — tuned to the asset, indication, and geography.",
  },
  {
    n: "02",
    label: "Expert Validation",
    desc: "Senior HEOR and patient-evidence experts validate, contextualise, and translate patient signals into evidence-ready themes and strategic implications.",
  },
  {
    n: "03",
    label: "Strategic Delivery",
    desc: "Clients receive curated briefings, reports, and workshops — not raw analytics or self-serve dashboard outputs.",
  },
];

export default function ArchitectureSection() {
  return (
    <section className="bg-ink-1 relative" data-testid="architecture-section">
      <div className="container-edge py-24 lg:py-32">
        <Reveal>
          <div className="eyebrow">How it works</div>
          <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.75rem] tracking-tight mt-4 text-parchment-bright max-w-4xl leading-[1.05]">
            Three layers. AI-enabled. Expert-validated.
          </h2>
          <p className="mt-6 max-w-3xl text-parchment/75 text-lg leading-relaxed">
            Voice2Evidence works through three reinforcing layers: signal synthesis, expert validation, and structured strategic delivery.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.08] border border-white/[0.08]">
          {LAYERS.map((l, i) => (
            <Reveal
              key={l.n}
              delay={i * 100}
              className={`p-8 lg:p-10 card-dark-hover flex flex-col ${i === 1 ? "bg-ink-2" : "bg-ink-1"}`}
              data-testid={`architecture-layer-${l.n}`}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-serif text-5xl text-rust/80">{l.n}</span>
                {i < LAYERS.length - 1 && (
                  <span className="hidden md:inline-block font-mono text-parchment/30">→</span>
                )}
              </div>
              <h3 className="font-serif text-[1.7rem] md:text-[1.85rem] text-parchment-bright leading-snug">
                {l.label}
              </h3>
              <p className="mt-5 text-parchment/75 leading-relaxed text-[15px]">{l.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
